const FormDataLayer = {
    init(form) {
        if (!window.useDatalayer) return;

        window.dataLayer_form = {
            event: 'begin_checkout',
            ecommerce: {
                items: [{
                    item_category4: 'interest',
                    quantity: '1'
                }]
            }
        };

        this.pushHiddenInputs(form);
    },

    isPushed: function () {

        let dataLayerStartIndex;

        if (typeof dataLayer !== "undefined") {
            dataLayerStartIndex = dataLayer.filter((layer) => {
                return layer.event === dataLayer_form.event;
            });
        }

        return dataLayerStartIndex.length !== 0;
    },

    pushHiddenInputs(form) {

        form.find('input, [type], select').each((i, el) => {
            const val = $(el).val();
            let name = $(el).attr('name');
            if (!val || !name || name === 'g-recaptcha-response' || name === 'gclid_field') return;

            name = $(el).attr('dataLayerName') ? $(el).attr('dataLayerName') : name;
            dataLayer_form.ecommerce.items[0][name] = val;
        })
    },

    afterSubmit(form, response) {

        const data = JSON.parse(response.data.post);
        console.log(data.l)
        delete data['gclid_field'];
        delete data['g-recaptcha-response'];

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: data.datalayer_event,
            lead: {
                id: response.leadID,
                ...data
            }
        });
    }
}
export default FormDataLayer;
window.FormDataLayer = FormDataLayer;